document.documentElement.classList.add('js');

document.querySelectorAll('[data-savings-calculator]').forEach((calculator) => {
  const spend = calculator.querySelector('[data-spend]');
  const waste = calculator.querySelector('[data-waste]');
  const prevent = calculator.querySelector('[data-prevent]');
  const price = Number(calculator.dataset.productPrice || 89);
  const money = new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD', maximumFractionDigits: 2 });
  const update = () => {
    const weekly = Number(spend.value) * (Number(waste.value) / 100) * (Number(prevent.value) / 100);
    const yearly = weekly * 52;
    const equivalents = price > 0 ? Math.max(1, Math.floor(yearly / price)) : 0;
    calculator.querySelector('[data-spend-output]').textContent = `$${spend.value}`;
    calculator.querySelector('[data-waste-output]').textContent = `${waste.value}%`;
    calculator.querySelector('[data-prevent-output]').textContent = `${prevent.value}%`;
    calculator.querySelector('[data-weekly-result]').textContent = money.format(weekly);
    calculator.querySelector('[data-yearly-result]').textContent = money.format(yearly).replace('.00', '');
    calculator.querySelector('[data-equivalent-result]').textContent = `About ${equivalents} ${equivalents === 1 ? 'ClipOne' : 'ClipOnes'}`;
  };
  [spend, waste, prevent].forEach((input) => input.addEventListener('input', update));
  update();
});

document.querySelectorAll('[data-bundle-box]').forEach((box) => {
  const form = box.querySelector('[data-bundle-form]');
  const panelTemplate = box.querySelector('[data-unlock-panel]');
  const total = box.querySelector('[data-bundle-total]');
  const saving = box.querySelector('[data-saving-total]');
  const afterpayAmount = box.querySelector('[data-afterpay-amount]');
  const choices = [...box.querySelectorAll('[data-bundle-choice]')];
  if (!form) return;
  const format = (value) => new Intl.NumberFormat('en-AU', { style: 'currency', currency: 'AUD' }).format(value);
  choices.forEach((choice, index) => {
    const option = document.createElement('div');
    option.className = `bundle-option${choice.dataset.compact === 'true' ? ' bundle-option--compact' : ''}`;
    choice.before(option);
    option.append(choice);
    const panel = panelTemplate ? panelTemplate.cloneNode(true) : null;
    if (panel) {
      panel.open = false;
      option.append(panel);
    }
    choice._valuePanel = panel;
    choice._option = option;
  });
  panelTemplate?.remove();
  const updateBundle = () => {
    const selected = box.querySelector('input[name="bundle_choice"]:checked');
    const selectedChoice = selected.closest('[data-bundle-choice]');
    const unlocked = Number(selected.dataset.price) >= 79;
    choices.forEach((choice) => {
      const choiceInput = choice.querySelector('input[name="bundle_choice"]');
      const panel = choice._valuePanel;
      const choiceUnlocked = choice === selectedChoice && Number(choiceInput.dataset.price) >= 79;
      choice.classList.toggle('is-selected', choice === selectedChoice);
      choice._option.classList.toggle('is-selected', choice === selectedChoice);
      if (!panel) return;
      panel.hidden = choice !== selectedChoice;
      panel.classList.toggle('is-unlocked', choiceUnlocked);
      panel.querySelectorAll('[data-unlock-icon]').forEach((icon) => { icon.textContent = choiceUnlocked ? '✓' : '🔒'; });
      panel.querySelector('[data-bags-title]').textContent = 'Included bags';
      panel.querySelector('[data-bags-copy]').textContent = choiceInput.dataset.bags;
      panel.querySelector('[data-bags-title]').closest('.unlock-row').hidden = choiceInput.value === 'essential';
      panel.querySelector('[data-bags-value]').textContent = choiceUnlocked ? format(Number(choiceInput.dataset.bagValue)) : '';
      const starterRow=panel.querySelector('.unlock-row.is-always-on');if(starterRow)starterRow.hidden=choiceInput.value!=='essential';
      panel.querySelector('[data-shipping-title]').textContent = choiceUnlocked ? 'Free standard shipping' : 'Standard shipping';
      panel.querySelector('[data-shipping-copy]').textContent = choiceUnlocked ? 'Eligible Australian orders of $79 or more after discounts. Availability at checkout.' : 'Shipping calculated at checkout.';
      panel.querySelector('[data-shipping-label]').textContent = '';
      const choiceRetail = Number(choiceInput.dataset.retail || (62 + Number(choiceInput.dataset.bagValue)));
      panel.querySelector('[data-retail-total]').textContent = format(choiceRetail);
    });
    const retailValue = Number(selected.dataset.retail || (62 + Number(selected.dataset.bagValue)));
    const includes = box.closest('.shopify-section').querySelector('.oc-inline-details details:first-child .oc-inline-details__content');
    if (includes && selected.dataset.retail) includes.textContent = '1 × ClipOne cordless sealer + ' + selected.dataset.bags + ' bags.';
    saving.textContent = format(retailValue - Number(selected.dataset.price));
    total.textContent = format(Number(selected.dataset.price));
    if (afterpayAmount) afterpayAmount.textContent = format(Number(selected.dataset.price) / 4);
  };
  choices.forEach((choice) => {
    choice._option.addEventListener('click', () => {
      const input = choice.querySelector('input[name="bundle_choice"]');
      if (!input.checked) {
        input.checked = true;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });
  });
  box.querySelectorAll('input[name="bundle_choice"]').forEach((input) => input.addEventListener('change', updateBundle));
  updateBundle();
  form.addEventListener('submit', async (event) => {
    const selected = box.querySelector('input[name="bundle_choice"]:checked');
    event.preventDefault();
    const button = form.querySelector('[type="submit"]');
    const mainVariant = form.querySelector('[data-main-variant]').value;
    button.disabled = true; button.textContent = 'Adding…';
    try {
      const variantId = selected.dataset.mode === 'essential' ? mainVariant : selected.dataset.variant;
      const items = [{ id: Number(variantId), quantity: Number(selected.dataset.quantity || 1) }];
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
      if (!response.ok) throw new Error('Cart request failed');
      const cart = await fetch('/cart.js').then((result) => result.json());
      document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
      button.textContent = '✓ Added to cart';
      button.classList.add('is-added');
      setTimeout(() => { button.disabled = false; button.textContent = 'Add to cart'; button.classList.remove('is-added'); }, 1800);
    } catch (error) {
      button.disabled = false; button.textContent = 'Add to cart';
      window.alert('We could not add the bundle. Please try again.');
    }
  });
});

document.querySelectorAll('[data-ajax-product-form]').forEach((form) => form.addEventListener('submit', async (event) => {
  event.preventDefault();
  const button = form.querySelector('[type="submit"]');
  const variantId = form.querySelector('[name="id"]').value;
  const warranty = form.closest('.shopify-section')?.querySelector('[data-heatone-warranty]');
  const warrantyToggle = warranty?.querySelector('[data-heatone-warranty-toggle]');
  const quantity = Math.max(1, Number(form.querySelector('[name="quantity"]')?.value) || 1);
  const items = typeof form.kinusaigaItems === "function" ? form.kinusaigaItems() : [{ id: Number(variantId), quantity: warranty ? quantity : 1 }];
  if (warranty && !warranty.hidden && warrantyToggle?.checked) {
    items[0].properties = { '_Extended warranty': '+1 year' };
    items.push({ id: Number(warranty.dataset.addonVariantId), quantity,
      parent_id: Number(variantId), properties: { 'Cover': '+1 year · 2 years total cover' } });
  }
  if (warrantyToggle) warrantyToggle.disabled = true;
  button.disabled = true; button.textContent = 'Adding…';
  try {
    const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
    if (!response.ok) throw new Error('Cart request failed');
    const cart = await fetch('/cart.js').then((result) => result.json());
    document.querySelectorAll('.cart-count').forEach((count) => { count.textContent = cart.item_count; });
    button.textContent = '✓ Added to cart'; button.classList.add('is-added');
    setTimeout(() => { button.disabled = false; if (warrantyToggle) warrantyToggle.disabled = false; button.textContent = 'Add to cart'; button.classList.remove('is-added'); }, 1800);
  } catch (error) {
    button.disabled = false; if (warrantyToggle) warrantyToggle.disabled = false; button.textContent = 'Add to cart';
    window.alert('We could not add this item. Please try again.');
  }
}));

document.querySelectorAll('[data-cart-upsell]').forEach((cart) => {
  const reminder = cart.querySelector('[data-shipping-reminder]');
  let allowCheckout = false;
  let quantityTimer;
  cart.querySelectorAll('[data-random-bag-upsell]').forEach((upsell) => {
    const items = [...upsell.querySelectorAll('[data-random-bag-item]')];
    for (let index = items.length - 1; index > 0; index -= 1) {
      const swapIndex = Math.floor(Math.random() * (index + 1));
      [items[index], items[swapIndex]] = [items[swapIndex], items[index]];
    }
    items.slice(0, 2).forEach((item) => { item.hidden = false; });
    upsell.hidden = items.length === 0;
  });
  cart.querySelectorAll('[data-auto-quantity]').forEach((input) => {
    input.addEventListener('input', () => {
      window.clearTimeout(quantityTimer);
      quantityTimer = window.setTimeout(async () => {
        const quantity = Math.max(0, Number.parseInt(input.value || '0', 10));
        input.disabled = true;
        cart.classList.add('is-updating');
        try {
          const response = await fetch('/cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: Number(input.dataset.cartLine), quantity }) });
          if (!response.ok) throw new Error('Cart update failed');
          window.location.reload();
        } catch (error) {
          input.disabled = false;
          cart.classList.remove('is-updating');
          window.alert('We could not update the quantity. Please try again.');
        }
      }, 550);
    });
  });
  cart.querySelectorAll('[data-cart-add]').forEach((button) => button.addEventListener('click', async () => {
    const original = button.innerHTML;
    button.disabled = true;
    button.classList.add('is-loading');
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(button.dataset.cartAdd), quantity: 1 }] }) });
      if (!response.ok) throw new Error('Cart request failed');
      window.location.reload();
    } catch (error) {
      button.disabled = false;
      button.classList.remove('is-loading');
      button.innerHTML = original;
      window.alert('We could not add these bags. Please try again.');
    }
  }));
  const checkout = cart.querySelector('[data-checkout-trigger]');
  if (checkout && reminder) checkout.addEventListener('click', (event) => {
    if (allowCheckout) return;
    event.preventDefault();
    reminder.showModal();
  });
  cart.querySelector('[data-reminder-close]')?.addEventListener('click', () => reminder.close());
  cart.querySelector('[data-continue-checkout]')?.addEventListener('click', () => { allowCheckout = true; });
  reminder?.addEventListener('click', (event) => { if (event.target === reminder) reminder.close(); });
});

document.querySelectorAll('[data-product-gallery]').forEach((gallery) => {
  const media = [...gallery.querySelectorAll('[data-product-gallery-media]')];
  const stage = gallery.querySelector('.product-gallery__stage');
  const thumbsRail = gallery.querySelector('.product-gallery__thumbs');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const currentLabel = gallery.querySelector('[data-gallery-current]');
  if (!media.length || thumbs.length < 2) return;
  let current = Math.max(0, media.findIndex(item => !item.hidden));
  const show = (next) => {
    current = (next + thumbs.length) % thumbs.length;
    const thumb = thumbs[current];
    media.forEach((item, index) => {
      const active = index === current;
      item.hidden = !active;
      if (!active && item.tagName === 'VIDEO') item.pause();
    });
    thumbs.forEach((item, index) => {
      const active = index === current;
      item.classList.toggle('is-active', active);
      item.setAttribute('aria-pressed', String(active));
    });
    if (currentLabel) currentLabel.textContent = String(current + 1);
    if (thumbsRail) {
      const left = thumb.offsetLeft - thumbsRail.offsetLeft - (thumbsRail.clientWidth - thumb.offsetWidth) / 2;
      thumbsRail.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    }
  };
  thumbs.forEach((thumb, index) => thumb.addEventListener('click', () => show(index)));
  gallery.querySelector('[data-gallery-prev]')?.addEventListener('click', () => show(current - 1));
  gallery.querySelector('[data-gallery-next]')?.addEventListener('click', () => show(current + 1));

  if (stage) {
    let pointerStartX = 0;
    let pointerStartY = 0;
    let activePointer = null;

    stage.addEventListener('pointerdown', (event) => {
      if (event.button !== undefined && event.button !== 0) return;
      activePointer = event.pointerId;
      pointerStartX = event.clientX;
      pointerStartY = event.clientY;
    }, { passive: true });

    stage.addEventListener('pointerup', (event) => {
      if (activePointer !== null && event.pointerId !== activePointer) return;
      const deltaX = event.clientX - pointerStartX;
      const deltaY = event.clientY - pointerStartY;
      activePointer = null;
      if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) return;
      show(current + (deltaX < 0 ? 1 : -1));
    }, { passive: true });

    stage.addEventListener('pointercancel', () => { activePointer = null; }, { passive: true });
  }
});

document.querySelectorAll('[data-promo-carousel]').forEach((carousel) => {
  const slides = [...carousel.querySelectorAll('[data-promo-slide]')];
  let current = 0;
  let rotation;
  const show = (next) => {
    current = (next + slides.length) % slides.length;
    slides.forEach((slide, index) => slide.classList.toggle('is-active', index === current));
  };
  const interval = Number(carousel.dataset.rotationSpeed || 4500);
  const start = () => { window.clearInterval(rotation); rotation = window.setInterval(() => show(current + 1), interval); };
  carousel.querySelector('[data-promo-prev]').addEventListener('click', () => { show(current - 1); start(); });
  carousel.querySelector('[data-promo-next]').addEventListener('click', () => { show(current + 1); start(); });
  carousel.addEventListener('mouseenter', () => window.clearInterval(rotation));
  carousel.addEventListener('mouseleave', start);
  carousel.addEventListener('focusin', () => window.clearInterval(rotation));
  carousel.addEventListener('focusout', start);
  start();
});


/* Countdown managed by oc-sale-cycle.js. */


/* OPENCLIP_DEMO_LIVE_VIEWERS — replace this random value with the production analytics source before launch. */
document.addEventListener("change",event=>{const input=event.target.closest?.("[data-price]");if(!input)return;const amount=document.querySelector("[data-afterpay-amount]"),price=Number(input.dataset.price);amount&&Number.isFinite(price)&&(amount.textContent=new Intl.NumberFormat("en-AU",{style:"currency",currency:"AUD"}).format(price/4))}),document.querySelectorAll("[data-live-viewers]").forEach((node) => {
  node.textContent = String(Math.floor(Math.random() * 10) + 1);
});